module.exports = __webpack_public_path__ + "img/sup_register_banner.ca8c091b.png";